// src/Components/Streak/streakApi.ts
// Wrappers for /api/streak. Every call carries the browser timezone so the
// server counts days in the learner's local calendar.
import axios from "axios";
import { getAccessToken } from "../Utils/TokenRefresh";
import { browserTimezone, StreakResult, StreakSummary, Reward } from "./streakModel";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

async function headers(): Promise<Record<string, string>> {
  let token: string | null = null;
  try {
    token = await getAccessToken();
  } catch {
    token = null;
  }
  token = token || localStorage.getItem("accessToken");
  const h: Record<string, string> = {};
  if (token) h.Authorization = `Bearer ${token}`;
  const tz = browserTimezone();
  if (tz) h["X-Timezone"] = tz;
  return h;
}

export async function fetchStreakSummary(): Promise<StreakSummary> {
  const r = await axios.get(`${API_BASE}/api/streak`, { headers: await headers(), params: { _ts: Date.now() } });
  return r.data as StreakSummary;
}

/** Records a lesson unit end (legacy endpoint, same rules as every activity). */
export async function postStreakActivity(): Promise<StreakResult | null> {
  const r = await axios.post(`${API_BASE}/api/streak/updateStreak`, { timezone: browserTimezone() }, { headers: await headers() });
  return (r.data?.streak as StreakResult) ?? null;
}

export interface ClaimResult {
  ok: boolean;
  alreadyClaimed: boolean;
  days: number;
  reward: Reward;
  starsAdded: number;
  totalStars: number;
  coinCount: number;
  moonrockCount: number;
}

export async function claimMilestone(days: number): Promise<ClaimResult> {
  const r = await axios.post(`${API_BASE}/api/streak/milestones/${days}/claim`, {}, { headers: await headers() });
  return r.data as ClaimResult;
}
